module.exports = __webpack_public_path__ + "static/img/reading.62133f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/reading.svg
// module id = P8lS
// module chunks = 0